import React from 'react';
import { connect } from 'react-redux';
import { userActions } from '../../state/stores/user';
import PropTypes from 'prop-types';
import { Welcome } from '../Welcome';
import { MainMenu } from '../MainMenu';

import styles from './header.module.scss';

import galotterylogo from './assets/ga-logo-hd.png';
import monopolylogo from './assets/ga-monopoly-logo.png';

export const Header = ({ user, mainMenu, logout }) => {
    return (
        <header className={styles.header}>
            <div className={styles.logoRow}>
                <a
                    href="https://www.galottery.com/en-us/home.html?utm_source=organic&utm_medium=secondchance&utm_campaign=monopoly&utm_content=homepage"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.logo}
                >
                    <img src={galotterylogo} alt="GA lottery" />
                </a>
                <a href="/monopoly" className={styles.promoLogoMobile}>
                    <img src={monopolylogo} alt="MONOPOLY For Life" />
                </a>
                <div className={styles.primaryNav}>
                    <MainMenu menuLinks={mainMenu} />
                </div>
                <Welcome {...user} logout={logout} />
            </div>
        </header>
    );
};

Header.propTypes = {
    user: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
    mainMenu: PropTypes.array.isRequired,
};

export default connect(
    ({ user }) => ({
        user,
    }),
    dispatch => ({
        logout: userActions(dispatch).logout,
    })
)(Header);
